/**
 * On combo flow existing_insurance field should be set to "true" only
 * on common-summary screen, other way it will lead to incorrect price.
 */
import { TRIPLE_FLOW_ID } from '../boilerplate/item-ids';

export default (kasko) => {
  kasko.addEventListener('route-changed', ({ current }) => {
    const state = kasko.getState().input;
    if ((current && current.path !== 'common-summary') || state.item_id !== TRIPLE_FLOW_ID) {
      return;
    }
    kasko.dispatchEvent('set-state-input', {
      existing_insurance: true,
    });
    kasko.dispatchEvent('set-form-input', {
      existing_insurance: true,
    });
  });
};
